<mat-progress-bar mode="indeterminate" [ngClass]="['routing-progress']" *ngIf="api.loading"></mat-progress-bar>
<div
  class="layout-wrapper"
  [ngClass]="{
    'layout-menu-horizontal': menuMode === 'horizontal',
    'layout-menu-popup': menuMode === 'popup',
    'layout-menu-overlay': menuMode === 'overlay',
    'layout-menu-static': menuMode === 'static',
    'layout-menu-static-inactive': menuMode == 'static' && menuActive === false
  }"
  (click)="onLayoutClick()"
>
  <div [ngClass]="{ 'layout-content': nav, newtab: isMatchGame || isWordGame || isTrivia || isCategorize }">
    <app-topbar *ngIf="!hideTopbar && !isHeaderFooter && nav"></app-topbar>
    <router-outlet></router-outlet>
    <app-footer *ngIf="!hideFooter && !isHeaderFooter && nav"></app-footer>
  </div>
</div>
